const g2WithQuotes = {
  numClones: 1,
  currentTranslateX: 0,
  originalSlides: [],
  state: {
    _activeIndex: 0,
    set activeIndex(value) {
      if (value !== this._activeIndex) {
        this._activeIndex = value;
        this.onActiveIndexChange(value);
      }
    },
    get activeIndex() {
      return this._activeIndex;
    },
  },
  init(el) {
    if (!el) return;
    this.state.onActiveIndexChange = this.onActiveIndexChange.bind(this);

    this.mainEl = el;
    this.slidesTrack = this.mainEl.querySelector(".g2-with-quotes__slides");
    this.nav = this.mainEl.querySelector(".g2-with-quotes__nav");
    this.originalSlides = Array.from(this.slidesTrack.querySelectorAll(".g2-with-quotes__slide"));
    this.cloneSlides();
    this.slides = Array.from(this.slidesTrack.querySelectorAll(".g2-with-quotes__slide"));
    this.centerSlides(0);
    this.renderNav();

    // Swipe Detection
    let touchStartX = 0;
    let touchEndX = 0;

    this.mainEl.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    this.mainEl.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    });

    let scrollTimeout;
    let scrollLock = false;
    this.mainEl.addEventListener(
      "wheel",
      (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault();
          if (scrollLock) return;
          scrollLock = true;

          if (e.deltaX >= 1 && e.deltaX < 20) {
            this.incrementActiveIndex();
          }
          if (e.deltaX <= -1 && e.deltaX > -20) {
            this.decrementActiveIndex();
          }

          scrollTimeout = setTimeout(() => {
            scrollLock = false;
          }, 500);
        }
      },
      { passive: false },
    );

    this.nav.addEventListener("click", (e) => {
      if (!e.target.classList.contains("g2-with-quotes__nav-item")) return;
      const index = Array.from(this.nav.children).indexOf(e.target);
      this.nav.querySelector(".active").classList.remove("active");
      e.target.classList.add("active");

      this.state.activeIndex = index % this.originalSlides.length;
    });
    window.addEventListener("resize", this.resize.bind(this));
  },
  handleSwipe(startX, endX) {
    const threshold = 50;
    if (startX - endX > threshold) {
      this.incrementActiveIndex();
    } else if (endX - startX > threshold) {
      this.decrementActiveIndex();
    }
  },
  decrementActiveIndex() {
    if (this.state.activeIndex === 0) {
      this.slidesTrack.style.transition = "none";

      const lastClone = this.slides[this.originalSlides.length * 2];
      const sliderRect = this.mainEl.getBoundingClientRect();
      const cloneRect = lastClone.getBoundingClientRect();
      const offset =
        cloneRect.left - sliderRect.left - (sliderRect.width / 2 - cloneRect.width / 2);
      this.currentTranslateX -= offset;
      this.slidesTrack.style.transform = `translateX(${this.currentTranslateX}px)`;

      void this.slidesTrack.offsetWidth;
      this.slidesTrack.style.transition = "";
      this.state.activeIndex = this.originalSlides.length - 1;
    } else {
      this.state.activeIndex =
        (this.state.activeIndex - 1 + this.originalSlides.length) % this.originalSlides.length;
    }
    this.nav.querySelector(".active").classList.remove("active");
    this.nav.querySelectorAll("button")[this.state.activeIndex].classList.add("active");
  },
  incrementActiveIndex() {
    if (this.state.activeIndex === this.originalSlides.length - 1) {
      this.slidesTrack.style.transition = "none";

      const firstClone = this.slides[this.originalSlides.length - 1];
      const sliderRect = this.mainEl.getBoundingClientRect();
      const cloneRect = firstClone.getBoundingClientRect();
      const offset =
        cloneRect.left - sliderRect.left - (sliderRect.width / 2 - cloneRect.width / 2);
      this.currentTranslateX -= offset;
      this.slidesTrack.style.transform = `translateX(${this.currentTranslateX}px)`;

      void this.slidesTrack.offsetWidth;
      this.slidesTrack.style.transition = "";
      this.state.activeIndex = 0;
    } else {
      this.state.activeIndex = (this.state.activeIndex + 1) % this.originalSlides.length;
    }
    this.nav.querySelector(".active").classList.remove("active");
    this.nav.querySelectorAll("button")[this.state.activeIndex].classList.add("active");
  },
  resize() {
    this.centerSlides(this.state.activeIndex);
  },
  renderNav() {
    if (!this.nav) return;
    const navFrag = document.createDocumentFragment();
    this.originalSlides.forEach((slide, index) => {
      const navItem = document.createElement("button");
      navItem.classList.add("g2-with-quotes__nav-item");
      navItem.classList.add("g2-with-quotes__nav-item");
      if (index === 0) {
        navItem.classList.add("active");
      }
      navItem.setAttribute("aria-label", `Slide ${index + 1}`);
      navItem.setAttribute("aria-controls", `slide-${index}`);
      navItem.setAttribute("aria-selected", index === this.state.activeIndex);
      navFrag.appendChild(navItem);
    });
    this.nav.appendChild(navFrag);
  },
  cloneSlides() {
    this.originalSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("isClone");
      this.slidesTrack.insertBefore(clone, this.originalSlides[0]);
    });
    this.originalSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("isClone");
      this.slidesTrack.appendChild(clone);
    });
  },
  centerSlides(slideIndex = 0) {
    const slide = this.originalSlides[slideIndex];
    const containerRect = this.mainEl.getBoundingClientRect();

    const slideOffset = slide.offsetLeft;
    const containerCenter = containerRect.width / 2;
    const slideCenter = slide.offsetWidth / 2;

    const targetTranslate = containerCenter - slideOffset - slideCenter;

    this.currentTranslateX = targetTranslate;
    this.slidesTrack.style.transform = `translateX(${targetTranslate}px)`;
  },
  onActiveIndexChange(index) {
    this.centerSlides(index);
  },
};

document.addEventListener("DOMContentLoaded", function (event) {
  if (!document.querySelector(".g2-with-quotes")) return;

  g2WithQuotes.init(document.querySelector(".g2-with-quotes"));
});
